import { render, staticRenderFns } from "./NewsListDeleted.vue?vue&type=template&id=6a45c3fa&"
import script from "./NewsListDeleted.vue?vue&type=script&lang=js&"
export * from "./NewsListDeleted.vue?vue&type=script&lang=js&"
import style0 from "./NewsListDeleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports